import type { ReturnInventoryRestockTrigger, UpdateReturnPolicyPayload } from './api/returnsPolicyApi';

export interface ReturnPolicyFormState {
  returnsEnabled: boolean;
  returnWindowDays: string;
  returnShipmentWindowDays: string;
  ineligibleCategoryIds: string[];
  restockingFeeEnabled: boolean;
  restockingFeePercentage: string;
  restockInventoryTrigger: ReturnInventoryRestockTrigger;
  absorbShipping: boolean;
  policyText: string;
}

/** Blank means "no limit" — watchman leaves an omitted field untouched, but a 0 would
 *  mean the window closes immediately. Never coerce an empty string to a number. */
const numOrUndefined = (v: string): number | undefined =>
  v.trim() === '' ? undefined : Number(v);

/**
 * Shape the form into a watchman `PATCH /merchants/me/store-config` body.
 *
 * `restockingFeePercentage` is a plain 0-100 percentage — not a fraction like
 * `vatRate`, and not minor units. The fee is only sent while the fee toggle is on,
 * so turning the toggle off never silently keeps a stale percentage in play.
 */
export function buildReturnPolicyPayload(form: ReturnPolicyFormState): UpdateReturnPolicyPayload {
  return {
    returnsEnabled: form.returnsEnabled,
    returnWindowDays: numOrUndefined(form.returnWindowDays),
    returnShipmentWindowDays: numOrUndefined(form.returnShipmentWindowDays),
    ineligibleCategoryIds: form.ineligibleCategoryIds,
    restockingFeeEnabled: form.restockingFeeEnabled,
    restockingFeePercentage: form.restockingFeeEnabled
      ? numOrUndefined(form.restockingFeePercentage)
      : undefined,
    restockInventoryTrigger: form.restockInventoryTrigger,
    returnShippingCostAbsorbedByMerchant: form.absorbShipping,
    returnPolicy: form.policyText.trim() === '' ? undefined : form.policyText,
  };
}
